import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Sparkles, Upload, Wand2, Captions, ShieldCheck, Download } from "lucide-react";

export function SubscribeModal({ open, onOpenChange }) {
  const navigate = useNavigate();
  const perks = [
    { icon: Upload, label: "Upload videos & analyse footage" },
    { icon: Wand2, label: "Generate AI clip candidates" },
    { icon: Captions, label: "Auto captions & watermarks" },
    { icon: ShieldCheck, label: "Campaign compliance checks" },
    { icon: Download, label: "Export finished clips" },
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-950 border-white/10 max-w-md" data-testid="subscribe-modal">
        <DialogHeader>
          <div className="w-14 h-14 rounded-2xl bg-amber-500 flex items-center justify-center amber-glow mb-3">
            <Sparkles className="w-7 h-7 text-zinc-950" />
          </div>
          <DialogTitle className="font-display text-2xl">Unlock AI Clipping</DialogTitle>
        </DialogHeader>
        <p className="text-zinc-400 text-sm leading-relaxed">
          Upload videos, analyse footage, generate clips, add captions, apply campaign requirements
          and export your finished clips with a Clipstar subscription.
        </p>
        <div className="space-y-2.5 my-4">
          {perks.map((p, i) => (
            <div key={i} className="flex items-center gap-3 text-sm text-zinc-300">
              <div className="w-8 h-8 rounded-lg bg-violet-500/10 flex items-center justify-center">
                <p.icon className="w-4 h-4 text-violet-400" />
              </div>
              {p.label}
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <Button
            onClick={() => { onOpenChange(false); navigate("/pricing"); }}
            data-testid="modal-view-plans-btn"
            className="w-full bg-amber-500 hover:bg-amber-400 text-zinc-950 font-bold"
          >
            View Plans
          </Button>
          <Button
            onClick={() => { onOpenChange(false); navigate("/pricing"); }}
            data-testid="modal-continue-billing-btn"
            variant="outline"
            className="w-full border-white/10 hover:bg-white/5"
          >
            Continue to Billing
          </Button>
        </div>
        <p className="text-center text-xs text-zinc-500 mt-1">
          Browsing, saving & importing campaigns is always free.
        </p>
      </DialogContent>
    </Dialog>
  );
}
